<template>
	<section class="pt-60" id="products">
		<div class="container">
			<div class="row mt-4">
				<div id="products-title" class="col-md-12" contenteditable="false" v-html="quarkRead('products-title')"></div>
			</div>
			<div class="row">
				<div id="products-content" class="col-md-6" contenteditable="false" v-html="quarkRead('products-content')"></div>
				<div class="col-md-5 offset-md-1">
					<carousel ref="carousel" :perPage="1" :autoplay="true" :loop="true">
						<slide>
							<div>
								<h2>Application Note #1</h2>
								<!-- <p class="text-center">X-ray analysis of Zirconium oxide</p> -->
								<a href="/pdf/appnote1-ZrO.pdf">
									<img class="img-fluid border" src="/pdf/appnote1-ZrO-1.jpg" />
								</a>
							</div>
						</slide>
						<slide>
							<div>
								<h2>Application Note #2</h2>
								<!-- <p class="text-center">Identification of MnCO3</p> -->
								<a href="/pdf/appnote2-MnCO3.pdf">
									<img class="img-fluid border" src="/pdf/appnote2-MnCO3-1.jpg" />
								</a>
							</div>
						</slide>
						<slide>
							<div>
								<h2>Application Note #3</h2>
								<!-- <p class="text-center">Resolution of the planet</p> -->
								<a href="/pdf/appnote3-Resolution_of_the_planet.pdf">
									<img class="img-fluid border" src="/pdf/appnote3-Resolution_of_the_planet-1.jpg" />
								</a>
							</div>
						</slide>
						<slide>
							<div>
								<h2>Application Note #4</h2>
								<!-- <p class="text-center">Resolution of the planet</p> -->
								<a href="/pdf/appnote4-Archeology.pdf">
									<img class="img-fluid border" src="/pdf/appnote4-Archeology.jpg" />
								</a>
							</div>
						</slide>
						<slide>
							<div>
								<h2>Application Note #5</h2>
								<!-- <p class="text-center">Resolution of the planet</p> -->
								<a href="/pdf/appnote5-Energetic-material1.pdf">
									<img class="img-fluid border" src="/pdf/appnote5-Energetic-material1.jpg" />
								</a>
							</div>
						</slide>
					</carousel>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',
		content: []
	}),

	components: {
		Carousel,
		Slide
	},

	created() {
		console.clear();
		this.images = this.movie2;
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		}
	}
};
</script>
